import { createSelector } from "reselect";

import { IFilter, IImportFileState } from "./model";
import { IImportType, ImportTemplate, ImportFileInfo, ITelematicsCount } from "~/file-import/model";

export const FILE_IMPORT_DATA_KEY = "FILE_IMPORT_DATA";

interface IState {
    [FILE_IMPORT_DATA_KEY]: IImportFileState;
}

export const getFetchAllUsersFilter = (state: IState): IFilter =>
    state[FILE_IMPORT_DATA_KEY].filter;

export const getImportTypes = (state: IState): Map<string, IImportType> =>
    state[FILE_IMPORT_DATA_KEY].importTypes;

export const getImportTemplates = (state: IState): Map<string, ImportTemplate> =>
    state[FILE_IMPORT_DATA_KEY].importTemplates;

export const getImportFiles = (state: IState): Map<string, ImportFileInfo> =>
    state[FILE_IMPORT_DATA_KEY].importFiles;

export const getImportType = (state: IState, importTypeGuid: string): IImportType =>
    state[FILE_IMPORT_DATA_KEY].importTypes.get(importTypeGuid);

export const getImportTemplate = (state: IState, importTemplateGuid: string): ImportTemplate =>
    state[FILE_IMPORT_DATA_KEY].importTemplates.get(importTemplateGuid);

export const getImportFileInfo = (state: IState, importFileInfoGuid: string): ImportFileInfo =>
    state[FILE_IMPORT_DATA_KEY].importFiles.get(importFileInfoGuid);

export const isFetchingTypes = (state: IState): boolean =>
    state[FILE_IMPORT_DATA_KEY].fetchingTypes;

export const getImportTypeGuidToTemplateListMap = createSelector(
    getImportTemplates,
    (importTemplateMap) => {
        const importTypeGuidToTemplateListMap = new Map();
        for (const template of importTemplateMap.values()) {
            if (!importTypeGuidToTemplateListMap.has(template.importTypeGuid)) {
                importTypeGuidToTemplateListMap.set(template.importTypeGuid, []);
            }
            importTypeGuidToTemplateListMap.get(template.importTypeGuid).push(template);
        }
        return importTypeGuidToTemplateListMap;
    }
);

export const getImportTemplateGuidToImportFileListMap = createSelector(
    getImportFiles,
    (importFileMap) => {
        const importTemplateGuidToImportFileListMap = new Map();
        for (const ifo of importFileMap.values()) {
            if (!importTemplateGuidToImportFileListMap.has(ifo.templateGuid)) {
                importTemplateGuidToImportFileListMap.set(ifo.templateGuid, []);
            }
            importTemplateGuidToImportFileListMap.get(ifo.templateGuid).push(ifo);
        }
        return importTemplateGuidToImportFileListMap;
    }
);

export const getSearchValue = (state: IState): string => state[FILE_IMPORT_DATA_KEY].searchValue;

export const getIsTelematicsUser = (state: unknown): boolean => {
    return state[FILE_IMPORT_DATA_KEY].isTelematicsUser;
};

export const getIsTelematicsProcessing = (state: unknown): boolean => {
    return state[FILE_IMPORT_DATA_KEY].isTelematicsProcessing;
};

export const getTelematicsCounts = (state: unknown): ITelematicsCount => {
    return state[FILE_IMPORT_DATA_KEY].telematicsCounts;
};
